import { createModalStoreFactory } from '@/features/_shared/stores/create-modal.store';
import { useShallow } from 'zustand/react/shallow';
import type { IOTPModalProps, TOTPModalType } from '../otp-modal/otp-modal';
import { ISignOutModalProps, TSignOutModalType } from '../signout-modal/sign-out-modal';
import { ICredentialModalProps, TCredentialModalType } from '../credential-modal/credential-modal';

// --------- Auth Modal Props ---------
export type TAuthModalRootTypes = TOTPModalType | TSignOutModalType | TCredentialModalType;

interface TAuthModalRootProps {
  OTPModal: IOTPModalProps;
  SignOutModal: ISignOutModalProps;
  CredentialModal: ICredentialModalProps;
}

export const useAuthModalRootStore = createModalStoreFactory<TAuthModalRootTypes, TAuthModalRootProps>();

export const useAuthModalRootActions = () => useAuthModalRootStore(useShallow((state) => state.actions));
